

















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore";

@Component({
  name: "sex",
})
export default class sex extends Vue {
  private answer = "";

  private zItem!: any;
  @Prop({ type: String, default: "EDIT" }) viewMode!: string;

  @Prop({ type: Number, default: 0 }) zIndex!: number;
  @Prop({ type: Boolean, default: true }) showScore!: boolean;
  @Prop({ type: String, default: "" }) businessType!: string;
  @Prop({ type: Boolean, default: true }) Required!: boolean;
  @Watch("zIndex", { immediate: true })
  // eslint-disable-next-line
  // watchIndex() {}
  @Prop({ type: Object, default: {} })
  item!: any;
  @Watch("item", { immediate: true, deep: true })
  dataChage(value: any) {
    this.zItem = value;
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        this.answer = value.answer;
      }
    }
  }

  get questionnaireType() {
    return this.businessType || QuestionnaireEditModule.questionnaireType;
  }
}
